import {useSelector} from 'react-redux';
import MissedVideoCallOutlinedIcon from '@mui/icons-material/MissedVideoCallOutlined';
import {Stack} from '@mui/material';

import {selectMissedCallBellLogsCount} from '@/redux/commonCalls/selectors';

import {useMissedCallBellLogsCounter} from './useMissedCallBellLogsCounter';

import styles from './callBellLogsMissedCallsCounter.module.scss';

export const CallBellLogsMissedCallsCounter = () => {
    const counter = useSelector(selectMissedCallBellLogsCount);
    useMissedCallBellLogsCounter();

    return (
        <Stack position="relative">
            <MissedVideoCallOutlinedIcon sx={{fontSize: '32px !important', ml: '13px !important'}} />
            {counter > 0 && <span className={styles.counter}>{counter}</span>}
        </Stack>
    );
};
